import React, {useEffect, useState} from "react";
import {Apis} from "../util/data";
import axios from "axios";
import {useDropzone} from "react-dropzone";
import {errorToast, successToast} from "./layout/ToastStyles";
import {FaFileImage} from "react-icons/fa";

const UploadConsejeria =({setAction, setTitle,...props}) => {

  const [file, setFile] = useState(null);
  const [img, setImg] = useState('');

  const upload = async () => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const {data} = await axios.post(Apis.PROD + '/images/upload/consejeria/' + props.id , formData)
      if(data) successToast("Se ha subido correctamente")
    }
    catch (error){
      errorToast("Error al subir la imagen")
      console.log(error)
    }
  }

  useEffect(()=>{
    if(props.url){
      setImg(props.url);
    }
  },[props])

  useEffect(() => {
    setTitle("Subir foto consejeria")
    setAction(()=>upload)
  }, [file])

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      setFile(acceptedFiles[0]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ accept: {'image/*': ['.jpeg', '.jpg', '.png']},maxFiles: 1, onDrop });

  return (
    <div style={{display:'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
      {img.length > 0 &&
        <div style={{flexDirection: 'column', alignItems: 'center',display:'flex', marginBottom: 8}}>
          <label style={{fontWeight: 'bold'}}>Foto actual</label>
          <img style={{height: 120, width: 120}} src={img} alt="No hay imagen"/>
        </div>}
      <div {...getRootProps()} style={{cursor: 'pointer' ,border: '1px dashed #ccc', padding: '20px', textAlign: 'center' }}>
        <input {...getInputProps()} />
        {file ? (
          <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <FaFileImage size={24} />
            <p>{file.name}</p>
          </div>
        ) : (
          <p>Arrastra una imagen o haz clic para seleccionar un archivo</p>
        )}
      </div>
    </div>
  );

}

export default UploadConsejeria;